import { Link } from "react-router";
import type { Language } from "../config/site";
import { CodeMotif } from "../components/CodeMotif";

export function PlayPage({ language }: { language: Language }) {
  const isTurkish = language === "tr";
  const prefix = isTurkish ? "/tr" : "";
  return (
    <section className="coming-soon marketing-width">
      <div><p className="eyebrow">VAULTPIN FOR WEB</p><h1>{isTurkish ? "Web kasası henüz kapalı." : "The web vault is still closed."}</h1><p>{isTurkish ? "VaultPin şu anda native bir iOS oyunudur. Web sürümü ileride bu rotada yerini alacak; bugün burada sahte bir oyun deneyimi göstermiyoruz." : "VaultPin is currently a native iOS game. A future web version can live on this route; there is no pretend game experience here today."}</p><Link className="button button--primary" to={`${prefix}/`}>{isTurkish ? "Ana sayfaya dön" : "Return home"}</Link></div>
      <div className="coming-soon__visual"><CodeMotif /></div>
    </section>
  );
}
